import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "hero",
  id: "home"
}
const _hoisted_2 = { class: "hero-image-full" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "hero-content" }
const _hoisted_5 = {
  class: "services",
  id: "services"
}
const _hoisted_6 = { class: "service-block" }
const _hoisted_7 = { class: "service-image" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "service-block" }
const _hoisted_10 = { class: "service-image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  class: "portfolio-cta",
  id: "portfolio"
}
const _hoisted_13 = { class: "portfolio-preview-grid" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "portfolio-cta-text" }
const _hoisted_16 = {
  class: "contact",
  id: "contact"
}
const _hoisted_17 = { class: "contact-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavBar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weddingPhotos, (img, i) => {
          return (_openBlock(), _createElementBlock("img", {
            key: 'w'+i,
            src: img,
            alt: "Wedding Photography",
            class: _normalizeClass({ active: i === _ctx.weddingIndex }),
            style: _normalizeStyle(i === 2 ? { objectFit: 'cover', objectPosition: 'center top' } : i === 1 ? { objectFit: 'cover', objectPosition: 'center 20%' } : i === 4 ? { objectFit: 'cover', objectPosition: 'center 65%' } : i === 6 ? { objectFit: 'cover', objectPosition: 'center 25%' } : {})
          }, null, 14, _hoisted_3))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", null, [
          _createTextVNode("Your Day."),
          _createElementVNode("br"),
          _createElementVNode("span", { class: "italic" }, "Exactly"),
          _createTextVNode(" As It Was.")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "hero-subtitle" }, "The moments between the moments.", -1)),
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "hero-cta"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Inquire Now", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("section", {
      class: "about",
      id: "about"
    }, [
      _createElementVNode("div", { class: "monogram" }, "EL"),
      _createElementVNode("h2", null, "\"We do not remember days, we remember moments.\""),
      _createElementVNode("p", { class: "about-quote" }, "— Cesare Pavese"),
      _createElementVNode("p", null, "That's been true every single time I've shown up to a wedding."),
      _createElementVNode("p", null, "There's a version of your day that only exists for a few hours. The way he looked at you when you walked in before anyone else saw. That moment between songs when everyone was just... there. Your mom's face when she realized it was really happening."),
      _createElementVNode("p", null, "I'm there for all of it — quietly, in the background — making sure none of it disappears."),
      _createElementVNode("a", {
        href: "#services",
        class: "about-cta"
      }, "Book Your Experience")
    ], -1)),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weddingServicePhotos, (img, i) => {
            return (_openBlock(), _createElementBlock("img", {
              key: 'ws'+i,
              src: img,
              alt: "Wedding Photography",
              class: _normalizeClass({ active: i === _ctx.weddingServiceIndex })
            }, null, 10, _hoisted_8))
          }), 128))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "service-content" }, [
          _createElementVNode("h3", null, "Weddings"),
          _createElementVNode("p", null, "Your wedding day is going to be a blur — in the best way. I'm not going to slow it down or make you pose through it. I'm just going to be there, watching it all happen."),
          _createElementVNode("p", null, "And when it's over and you finally sit down and breathe, you'll have photos that remind you exactly how it felt.")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couplesPhotos, (img, i) => {
            return (_openBlock(), _createElementBlock("img", {
              key: 'cs'+i,
              src: img,
              alt: "Couples Photography",
              class: _normalizeClass({ active: i === _ctx.couplesIndex })
            }, null, 10, _hoisted_11))
          }), 128))
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "service-content" }, [
          _createElementVNode("h3", null, "Couples"),
          _createElementVNode("p", null, "I don't want you to \"do a pose.\" I want you to just hang out with each other and let me follow you around. Tell me how you met. Show me your favorite spot. Be weird together."),
          _createElementVNode("p", null, "That's where the good photos are.")
        ], -1))
      ])
    ]),
    _cache[10] || (_cache[10] = _createStaticVNode("<section class=\"philosophy\" data-v-447fcbdc><p class=\"philosophy-label\" data-v-447fcbdc>The Promise</p><h2 data-v-447fcbdc>I&#39;ve been doing this long enough to know — the photos people actually treasure aren&#39;t the ones where everyone looks <span class=\"highlight\" data-v-447fcbdc>perfect.</span> They&#39;re the ones where everyone looks <span class=\"highlight\" data-v-447fcbdc>real.</span></h2><a href=\"#about\" class=\"philosophy-cta\" data-v-447fcbdc>The Experience</a></section><section class=\"testimonial\" data-v-447fcbdc><div class=\"reviews-header\" data-v-447fcbdc><p class=\"reviews-label\" data-v-447fcbdc>Client Reviews</p><div class=\"reviews-rating\" data-v-447fcbdc><span class=\"stars\" data-v-447fcbdc>★★★★★</span><span class=\"rating-text\" data-v-447fcbdc>5.0 on Google · 5 reviews</span></div></div><div class=\"reviews-grid\" data-v-447fcbdc><div class=\"review-card\" data-v-447fcbdc><p class=\"review-text\" data-v-447fcbdc>&quot;Evelina captured such beautiful moments of our family. Truly felt so easy around her. Loved the way the photos turned out. Highly recommend if you need a photoshoot.&quot;</p><cite data-v-447fcbdc>— Anita Hanchar</cite></div><div class=\"review-card\" data-v-447fcbdc><p class=\"review-text\" data-v-447fcbdc>&quot;We wanted to capture our growing family during the holiday season and couldn&#39;t be more happy with how Evelina captured all the moments in such a short time. We felt at ease and even our son who is a bit shy warmed up to her. Definitely recommend her if you are looking for someone who is relatable, easy and good with kids!&quot;</p><cite data-v-447fcbdc>— Google Review</cite></div><div class=\"review-card\" data-v-447fcbdc><p class=\"review-text\" data-v-447fcbdc>&quot;We were impressed by the value of her services and final photographic output. She spent nearly an hour with our family which was more than she had initially intended and was quite pleasant throughout. Would highly recommend.&quot;</p><cite data-v-447fcbdc>— Isabel Cote</cite></div><div class=\"review-card\" data-v-447fcbdc><p class=\"review-text\" data-v-447fcbdc>&quot;So sweet to have her help shoot our wedding! Love her style.&quot;</p><cite data-v-447fcbdc>— Cayla Roberts</cite></div></div></section>", 2)),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewPhotos, (photo, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "preview-img",
            key: i
          }, [
            _createElementVNode("img", {
              src: photo,
              alt: "Portfolio preview"
            }, null, 8, _hoisted_14)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[6] || (_cache[6] = _createElementVNode("h2", null, [
          _createElementVNode("span", { class: "italic" }, "See"),
          _createTextVNode(" The Work")
        ], -1)),
        _createVNode(_component_router_link, {
          to: "/portfolio",
          class: "portfolio-cta-button"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("View Portfolio", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _cache[8] || (_cache[8] = _createStaticVNode("<h2 data-v-447fcbdc>Let&#39;s Talk</h2><p class=\"contact-subtitle\" data-v-447fcbdc>Tell me about your day, your family, your story. I want to know what matters to you.</p><div class=\"contact-grid\" data-v-447fcbdc><div class=\"contact-item\" data-v-447fcbdc><h3 data-v-447fcbdc>Email</h3><a href=\"mailto:evialinaphotography@gmail.com\" data-v-447fcbdc>evialinaphotography@gmail.com</a></div><div class=\"contact-item\" data-v-447fcbdc><h3 data-v-447fcbdc>Phone</h3><a href=\"tel:+18586342517\" data-v-447fcbdc>858-634-2517</a></div><div class=\"contact-item\" data-v-447fcbdc><h3 data-v-447fcbdc>Instagram</h3><a href=\"https://www.instagram.com/evelinalodiphotography/\" target=\"_blank\" data-v-447fcbdc>@evelinalodiphotography</a></div></div>", 3)),
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "contact-cta"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("Send an Inquiry", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_FooterComponent)
  ]))
}